import { useState } from 'react';
import { Box, Button, TextField, Modal, Divider, useMediaQuery, useTheme, Typography } from '@mui/material';
import { IProject } from '../../core/interfaces/project.interface';

export interface ProjectUpdateModalProps {
  project: IProject;
  field: string;
  onClose: () => void;
  onSaveClick: (value: string) => void;
}

export const ProjectUpdateModal = ({ project, field, onClose, onSaveClick }: ProjectUpdateModalProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [value, setValue] = useState(project[field] ?? '');

  return (
    <Modal open onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: isMobile ? '90vw' : '600px',
          height: isMobile ? '90vh' : 'auto',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" component="h2">
          Update {field}
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            my: 2,
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            value={value}
            sx={{ mr: 2 }}
            onChange={(e) => setValue(e.target.value)}
          />
        </Box>
        <Divider sx={{ my: 2 }} />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button
            onClick={() => onSaveClick(value)}
            variant="contained"
            sx={{
              backgroundColor: 'var(--gentian-blue)',
            }}
          >
            Save
          </Button>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              color: 'var(--gentian-black)',
              borderColor: 'var(--gentian-black)',
              '&:hover': {
                backgroundColor: 'var(--sundrop-yellow)',
                borderColor: 'var(--gentian-black)',
              },
            }}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
